import React from 'react'

const Edit = (props) => (
  <svg width={20} height={20} {...props}>
    <title>0354CCE0-85EB-447D-BC9E-559A72557842</title>
    <path
      d="M5.997 16.502l9.698-9.697L13.5 4.61l-9.698 9.697 2.194 2.194zM2.354 13.59c.057-.11.132-.214.226-.307L12.687 3.174c.06-.06.126-.113.194-.159l.032-.031 1.735-1.735a1.222 1.222 0 011.727.002l2.426 2.426c.477.477.478 1.253.003 1.728L17.069 7.14l-.52.52-.01-.012-9.797 9.796c-.077.077-.16.141-.25.193a.726.726 0 01-.481.427l-4.33 1.212a.735.735 0 01-.905-.905l1.212-4.33a.725.725 0 01.366-.452zm-.001 1.124c.057.11.131.213.223.305l.52.52-.905 3.229-.905-.906 3.23-.904.49.49c.1.102.215.181.337.24l-.05.19-3.117-3.118.177-.046zm12.26-11.352l2.079 2.078 1.073-1.073c-.1.1-.1.253-.003.35L15.336 2.29a.248.248 0 00.35-.002L14.615 3.36z"
      fill="#222222"
      fillRule="nonzero"
    />
  </svg>
)

export default Edit
